export default function BrandLogo({ size = 48, glow = true }) {
    return (
        <img
            src="/logo.png"
            alt="Smokin' Mo's Southern BBQ"
            width={size}
            height={size}
            data-testid="brand-logo"
            style={{
                width: size,
                height: size,
                objectFit: "contain",
                filter: glow ? "drop-shadow(0 0 14px rgba(255,140,0,0.22))" : undefined,
            }}
        />
    );
}
